import { useState, useMemo } from "react";
import TabStrip from "../../../organisms/Tabstrip";
import { Box } from "@mui/material";
import { _getComponent } from "../../../organisms/Tabstrip/getComponent";
import Profile from "./tabs/MyProfile";
import ProfileSettings from "./tabs/ProfileSettings";

const MyProfile = ({userType}) => {
    const [activeTab, setActiveTab] = useState("My Profile");
  
    const onTabChange = (event, value) => {
      setActiveTab(value);
    };
  
    const data = useMemo(
      () => [
     
        {
          id: 0,
          label: "My Profile",
          view: <Profile/>,
        },
        {
          id: 1,
          label: "Security",
          view: <ProfileSettings/>,
        },
  
      ],
      []
    );
  
    return (
      <>
  
          <TabStrip  activeTab={activeTab} onTabChange={onTabChange} data={data} />
          <Box sx={{ width: "100%" }}>
            <Box sx={{ p: '20px 40px' }}>{_getComponent(data,activeTab)}</Box>
          </Box>
  
      </>
    )
  }
  
  export default MyProfile